(function () {
  function getDrawer() {
    return document.querySelector('.wc-drawer');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wc-drawer-open');
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wc-drawer-open');
  }

  // Open / Close via clicks
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-calc-open]')) {
      e.preventDefault();
      openDrawer();
    }

    if (e.target.closest('[data-calc-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });
})();
